<template>
  <hm-content title="编辑大屏配置">
    <el-form
      :model="ruleForm"
      :rules="rules"
      ref="ruleForm"
      label-width="100px"
      class="product-ruleForm"
    >
      <el-form-item label="发布门店：" prop="storeOutletIds">
        <el-select
          v-model="ruleForm.storeOutletIds"
          placeholder="选择门店"
          multiple
          size="small"
          filterable
        >
          <el-option
            v-for="item in storeList.list"
            :key="item.value"
            :disabled="ruleForm.storeOutletIds.length >= 3"
            :label="item.name"
            :value="item.id"
          ></el-option>
        </el-select>
        <span class="form-tip">（最多选择3个门店）</span>
      </el-form-item>
      <el-form-item label="设备编号：" prop="deviceId">
        <el-input
          size="small"
          clearable
          class="mr10 ipt"
          v-model.trim="ruleForm.deviceId"
          placeholder="请输入电视序列号"
        ></el-input>
      </el-form-item>
      <el-form-item label="标题图标：">
        <my-upload
          field="file"
          @crop-success="cropSuccess"
          @crop-upload-success="cropUploadSuccess"
          @crop-upload-fail="cropUploadFail"
          v-model="showNoticeImg"
          noCircle
          noSquare
          :width="100"
          :height="100"
          :params="{ storeId }"
          :url="$uploadUrl"
          img-format="png"
        ></my-upload>
        <el-button
          type="primary"
          size="small"
          v-show="!ruleForm.noticeImg"
          @click="toggleShow"
          >上传</el-button
        >
        <span class="form-tip">（标题图标尺寸建议100*100）</span>
        <div class="headPortrait-wrapper" v-show="ruleForm.noticeImg">
          <img @click="toggleShow" :src="ruleForm.noticeImg" alt="标题图标" />
        </div>
      </el-form-item>
      <el-form-item label="标题内容：" prop="noticeTitle">
        <el-input
          size="small"
          clearable
          @mousewheel.prevent.native
          v-model.trim="ruleForm.noticeTitle"
          class="mr10 ipt"
        ></el-input>
      </el-form-item>
      <el-form-item label="视频广告：">
        <!-- action必选参数, 上传的地址 -->
        <el-upload
          class="avatar-uploader el-upload--text"
          :action="$uploadUrl"
          :show-file-list="false"
          :on-success="handleVideoSuccess"
          :before-upload="beforeUploadVideo"
          :on-progress="uploadVideoProcess"
        >
          <video
            v-if="ruleForm.videoAd && !videoFlag"
            :src="ruleForm.videoAd"
            class="avatar"
            style="width: 300px"
            controls="controls"
          >
            您的浏览器不支持视频播放
          </video>
          <el-button
            v-else-if="!ruleForm.videoAd && !videoFlag"
            type="primary"
            size="small"
            >上传</el-button
          >
          <span class="form-tip">请上传mp4格式视频，且不超过20M</span>
          <el-progress
            v-if="videoFlag"
            :percentage="videoUploadPercent"
          ></el-progress>
        </el-upload>
      </el-form-item>
      <el-form-item label="轮播组图：">
        <my-upload
          field="file"
          @crop-success="cropSuccess"
          @crop-upload-success="cropUploadSuccess"
          @crop-upload-fail="cropUploadFail"
          v-model="showDetail"
          noCircle
          noSquare
          :width="345"
          :height="180"
          :params="{ storeId }"
          :url="$uploadUrl"
          img-format="png"
        ></my-upload>
        <el-button
          type="primary"
          size="small"
          v-show="uploadedDetailList.length < 6"
          @click="toggleShowDetail"
          >上传</el-button
        >
        <span class="form-tip"
          >（列表详情图可设置6张，图片尺寸建议345x180）</span
        >
        <ul class="flex flex-wrap">
          <li
            class="priview mr10"
            v-show="v"
            v-for="(v, i) in uploadedDetailList"
            :key="i"
          >
            <img :src="v" alt="列表详情图" />
            <div class="opreat-wrapper flex item-center flex-center">
              <el-button type="text" @click="setFirst(i)"
                >设为第一张图</el-button
              >
              <el-button type="text" @click="deleteListItem(i)">删除</el-button>
            </div>
          </li>
        </ul>
      </el-form-item>
      <el-form-item label="小程序码：">
        <my-upload
          field="file"
          @crop-success="cropSuccess"
          @crop-upload-success="cropUploadSuccess"
          @crop-upload-fail="cropUploadFail"
          v-model="showMpImg"
          noCircle
          noSquare
          :width="100"
          :height="100"
          :params="{ storeId }"
          :url="$uploadUrl"
          img-format="png"
        ></my-upload>
        <el-button
          type="primary"
          size="small"
          v-show="!ruleForm.mpImg"
          @click="toggleShowMpImg"
          >上传</el-button
        >
        <span class="form-tip">（小程序码尺寸建议100*100）</span>
        <div class="headPortrait-wrapper" v-show="ruleForm.mpImg">
          <img @click="toggleShowMpImg" :src="ruleForm.mpImg" alt="小程序码" />
        </div>
      </el-form-item>
      <el-form-item label="走马灯公告：">
        <el-input
          size="small"
          clearable
          class="mr10 ipt"
          type="textarea"
          v-model.trim="ruleForm.scrollAd"
        ></el-input>
      </el-form-item>
      <el-form-item label="备注：">
        <el-input
          size="small"
          clearable
          class="mr10 ipt"
          type="textarea"
          v-model.trim="ruleForm.description"
        ></el-input>
      </el-form-item>
      <el-form-item label="大屏状态：">
        <div class="flex item-center">
          <el-switch
            style="display: block"
            v-model="ruleForm.status"
            active-color="#13ce66"
            inactive-color="#ff4949"
            active-text="开启"
            inactive-text="关闭"
            :active-value="1"
            :inactive-value="0"
          ></el-switch>
          <span class="form-tip">（关闭后大屏提示暂停服务）</span>
        </div>
      </el-form-item>
      <div class="flex flex-center">
        <el-button type="primary" size="small" @click="submitForm('ruleForm')"
          >提交</el-button
        >
        <el-button size="small" @click="$router.back(-1)">返回</el-button>
      </div>
    </el-form>
  </hm-content>
</template>

<script>
import { mapGetters } from "vuex";
import { getLoginUser } from "@/utils/auth";
import myUpload from "vue-image-crop-upload";

 export default {
  components: {   myUpload },
  data() {
    return {
      showDetail: false,
      showMpImg: false,
      showNoticeImg: false,
      inputVisible: false,
      isMininum: true,
      videoFlag: false,
      type: 0,
      videoUploadPercent: 0,
      uploadedDetailList: [],
      listHeaderImgUrl: "",
      storeId: "",
      id: "",
      ruleForm: {
        storeOutletIds: [],
        deviceId: "",
        mpImg: "",
        noticeImg: "",
        noticeTitle: "",
        videoAd: "",
        imgAd: "",
        scrollAd: "",
        description: "",
        status: 1
      },
      rules: {
        storeOutletIds: {
          required: true,
          message: "请选择门店",
          trigger: "change"
        },
        deviceId: {
          required: true,
          message: "请输入设备编号",
          trigger: "blur"
        },
        noticeTitle: {
          min: 2,
          max: 20,
          message: "标题应大于2个字符且小于20个字"
        }
      }
    };
  },
  computed: mapGetters(["categoryList", "storeList", "rowScreen"]),
  watch: {
    rowScreen(val) {
      for (let key in val) {
        if (this.ruleForm.hasOwnProperty(key)) {
          this.ruleForm[key] = val[key];
          if (key === "storeOutletIds") {
            this.ruleForm[key] = val[key].map(v => +v);
          }
        }
      }
      this.uploadedDetailList = val.imgAd ? val.imgAd.split(",") : [];
    }
  },
  mounted() {
    const { storeId } = getLoginUser();
    this.storeId = storeId;
    this.id = this.$route.query.id;
    this.$store.dispatch("queryStoreList", { pageSize: 999 });
    this.$store.dispatch("queryRowScreen", { id: this.id });
  },
  methods: {
    beforeUploadVideo(file) {
      const isLt10M = file.size / 1024 / 1024 < 20;
      if (
        [
          "video/mp4"
          // "video/ogg",
          // "video/flv",
          // "video/avi",
          // "video/wmv",
          // "video/rmvb"
        ].indexOf(file.type) === -1
      ) {
        this.$message.error("请上传正确的视频格式");
        return false;
      }
      if (!isLt10M) {
        this.$message.error("上传视频大小不能超过20MB哦!");
        return false;
      }
    },
    uploadVideoProcess(event, file) {
      this.videoFlag = true;
      this.videoUploadPercent =
        file.percentage < 100 ? Math.round(file.percentage) : 99;
    },
    handleVideoSuccess(res) {
      //获取上传图片地址
      if (res.code === "0") {
        this.ruleForm.videoAd = res.result;
      } else {
        this.$message.error("视频上传失败，请重新上传！");
      }
      this.videoFlag = false;
      this.videoUploadPercent = 0;
    },
    toggleShow() {
      this.showNoticeImg = !this.showNoticeImg;
    },
    toggleShowDetail() {
      this.showDetail = !this.showDetail;
    },
    toggleShowMpImg() {
      this.showMpImg = !this.showMpImg;
    },
    cropSuccess() {},
    cropUploadSuccess(jsonData) {
      if (this.showNoticeImg) {
        this.ruleForm.noticeImg = jsonData.result;
      } else if (this.showDetail) {
        this.uploadedDetailList.push(jsonData.result);
      } else if (this.showMpImg) {
        this.ruleForm.mpImg = jsonData.result;
      }
    },
    cropUploadFail() {},
    minimum() {
      this.isMininum = !this.isMininum;
    },
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          let params = this.ruleForm;
          params = Object.assign(params, {
            imgAd: this.uploadedDetailList.join(","),
            id: this.id
          });
          this.$store.dispatch("editScreen", params).then(res => {
            if (res.code === "0") {
              this.$message({
                message: "操作成功",
                type: "success"
              });
              this.$router.back(-1);
            }
          });
        } else {
          return false;
        }
      });
    },
    // 移除上传文件
    handleRemove() {
      this.listHeaderImgUrl = "";
    },
    deleteListItem(i) {
      this.uploadedDetailList.splice(i, 1);
    },
    setFirst(i) {
      let tmp = this.uploadedDetailList[0];
      this.uploadedDetailList[0] = this.uploadedDetailList[i];
      this.uploadedDetailList[i] = tmp;
      this.$forceUpdate();
    }
  }
};
</script>

<style scoped lang="scss">
.button-new-tag {
  margin-left: 10px;
  height: 32px;
  line-height: 30px;
  padding-top: 0;
  padding-bottom: 0;
}
.input-new-tag {
  width: 90px;
  margin-left: 10px;
  vertical-align: bottom;
}
.priview {
  position: relative;
  width: 375px;
  height: 178px;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  img {
    width: 100%;
    height: 100%;
  }
  .opreat-wrapper {
    transition: opacity 0.2s linear;
    position: absolute;
    opacity: 0;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    border-radius: 6px;
  }

  &:hover {
    .opreat-wrapper {
      opacity: 1;
    }
  }
}

.preview-wrapper {
  position: fixed;
  top: 100px;
  right: 30px;
  width: 365px;
  z-index: 10;
}
</style>
